import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-333a4775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desk-container" }
const _hoisted_2 = { class: "big-screen" }
const _hoisted_3 = { class: "nums" }
const _hoisted_4 = { class: "nums-item" }
const _hoisted_5 = { class: "ni-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ni-content" }
const _hoisted_8 = { class: "nic-name" }
const _hoisted_9 = { class: "nic-num" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "emp-call"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cd-left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "cd-icon" }),
    /*#__PURE__*/_createElementVNode("div", { class: "cd-name" }, "通话数据概览")
  ])
], -1))
const _hoisted_14 = { class: "emp-call" }
const _hoisted_15 = { class: "emp_call_item" }
const _hoisted_16 = { class: "ni-icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "ni-content" }
const _hoisted_19 = { class: "nic-name" }
const _hoisted_20 = {
  key: 0,
  class: "nic-num"
}
const _hoisted_21 = {
  key: 1,
  class: "nic-num"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "分钟", -1))
const _hoisted_23 = {
  key: 1,
  class: "users"
}
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cd-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cd-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "cd-name" }, "业务员概览")
], -1))
const _hoisted_26 = { class: "cd-center" }
const _hoisted_27 = { class: "cd-tab" }
const _hoisted_28 = { class: "chart-label" }
const _hoisted_29 = { class: "cd-right" }
const _hoisted_30 = { class: "users-content" }
const _hoisted_31 = { class: "u-item" }
const _hoisted_32 = { class: "u-icon" }
const _hoisted_33 = { class: "u-content" }
const _hoisted_34 = { class: "uc-left-top" }
const _hoisted_35 = { class: "uc-name" }
const _hoisted_36 = { class: "uc-num-item" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "uc-num-item-num" }
const _hoisted_39 = {
  key: 2,
  class: "groups"
}
const _hoisted_40 = { class: "card-header" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cd-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cd-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "cd-name" }, "小组概览")
], -1))
const _hoisted_42 = { class: "cd-center" }
const _hoisted_43 = { class: "cd-tab" }
const _hoisted_44 = { class: "chart-label" }
const _hoisted_45 = { class: "cd-right" }
const _hoisted_46 = { class: "groups-content" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "g-icon" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "g-content" }
const _hoisted_51 = { class: "gc-left-top" }
const _hoisted_52 = { class: "gc-name" }
const _hoisted_53 = { class: "gc-num-item" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "gc-num-item-num" }
const _hoisted_56 = { class: "center" }
const _hoisted_57 = { class: "c-left" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cd-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "cd-name" }, "沟通计划")
], -1))
const _hoisted_59 = { class: "c-items" }
const _hoisted_60 = { class: "c-item" }
const _hoisted_61 = { class: "ci-icon" }
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "ci-content" }
const _hoisted_64 = { class: "cic-name" }
const _hoisted_65 = {
  key: 0,
  class: "cic-num"
}
const _hoisted_66 = {
  key: 1,
  class: "cic-num"
}
const _hoisted_67 = { class: "c-right" }
const _hoisted_68 = { class: "chart-label" }
const _hoisted_69 = { class: "ranks" }
const _hoisted_70 = { class: "card-header" }
const _hoisted_71 = { class: "cd-left" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cd-icon" }, null, -1))
const _hoisted_73 = { class: "cd-name" }
const _hoisted_74 = {
  key: 0,
  class: "cd-mine"
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "cd-right" }
const _hoisted_79 = { class: "r-content" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = ["src"]
const _hoisted_82 = ["src"]
const _hoisted_83 = ["src"]
const _hoisted_84 = { key: 3 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_87 = { class: "t-item" }
const _hoisted_88 = { class: "t-item-icon" }
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "t-item-label" }
const _hoisted_91 = { class: "itemModal" }

import { useStore } from "@/store";
import {computed, onMounted, ref, watch} from "vue";
import 'dayjs/locale/zh-cn'
import { useRouter } from "vue-router";
import { planTableConfig } from "./config/plan.config"
import { liveTableConfig } from "./config/live.config"
import { fuboTableConfig } from "./config/fubo.config"
import { voiceTableConfig } from "./config/voice.config"
import { replyTableConfig } from "./config/reply.config"
import {
  communicatePlan,
  numStatistics,
  columnChart,
  ranking,
  myRanking,
  overview,
  empCallStatistics, groupDetails
} from "@/service/desk-top/desk-top";
import CountTo from "@/components/CountTo.vue"
import dayjs from "dayjs";
import { ElLoading } from "element-plus";
import LfTable from "@/components/LfTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'desk-top',
  setup(__props) {


require('dayjs/locale/zh-cn')

const store = useStore()
const userInfo = store.state.login.userInfo
const roleNames: any = ref(userInfo.roles.map((role: any) => role.roleName))
const role = computed(() => {
  if (roleNames.value.indexOf('ROLE_ADMIN') > -1) {
    return 0
  } else if (roleNames.value.indexOf('ROLE_MANAGER') > -1) {
    return 1
  } else if (roleNames.value.indexOf('ROLE_GROUP') > -1){
    return 2
  } else if (roleNames.value.indexOf('ROLE_EMP') > -1){
    return 3
  } else {
    return 4
  }
})

const open = ref(false)
const changeOpen = () => {
  open.value = true
}

const changeClose = () => {
  open.value = false
}

const tools = ref([
  {
    icon: require('@/assets/ds-img/fast-menu.png'),
    label: '快捷菜单'
  },
  {
    icon: require('@/assets/ds-img/ai.png'),
    label: '小助手'
  }
])
const nums = ref([
  {
    name: '客户数量',
    icon: require('@/assets/ds-img/customers.png'),
    num: 0,
    link: '/main/custom-detail'
  },
  {
    name: '今日观看直播人数',
    icon: require('@/assets/ds-img/live.png'),
    num: 0
  },
  {
    name: '今日观看复播人数',
    icon: require('@/assets/ds-img/fubo.png'),
    num: 0
  },
  {
    name: '昨日观看直播人数',
    icon: require('@/assets/ds-img/yesterday.png'),
    num: 0
  },
  {
    name: '昨日复播观看人数',
    icon: require('@/assets/ds-img/fubo.png'),
    num: 0
  },
])

const empCall = ref([
  {
    name: '当月通话量',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0
  },
  {
    name: '当月通话时长',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0,
  },
  {
    name: '昨日通话量',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0
  },
  {
    name: '昨日通话时长',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0
  },
  {
    name: '今日通话量',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0
  },
  {
    name: '今日通话时长',
    icon: require('@/assets/ds-img/icon_call.png'),
    num: 0
  },
])

const loadNumStatistics = () => {
  numStatistics().then((res) => {
    nums.value[0].num = res.customerCount
    nums.value[1].num = res.liveCount
    nums.value[2].num = res.fbCount
    nums.value[3].num = res.yesterdayLiveCount
    nums.value[4].num = res.yesterdayFbCount
  })
}

const loadEmpCallStatistics = () => {
  empCallStatistics().then((res) => {
    empCall.value[0].num = res.totalCallCount
    empCall.value[1].num = convertMin(res.totalCallDuration)
    empCall.value[2].num = res.yesterdayCallCount
    empCall.value[3].num = convertMin(res.yesterdayCallDuration)
    empCall.value[4].num = res.todayCallCount
    empCall.value[5].num = convertMin(res.todayCallDuration)
  })
}

const router = useRouter()
const routeTo = (url: string) => {
  router.push({
    path: url
  })
}

const cItems = ref([
  {
    name: '总数',
    icon: require('@/assets/ds-img/total.png'),
    num: 0
  },
  {
    name: '正在开发',
    icon: require('@/assets/ds-img/progressing.png'),
    num: 0
  },
  {
    name: '已成交',
    icon: require('@/assets/ds-img/succ.png'),
    num: 0
  },
  {
    name: '今日计划是否完成',
    icon: require('@/assets/ds-img/plan-finish.png'),
    isFlag: true,
    num: ''
  }
])

const loadCommunicatePlan = () => {
  communicatePlan().then((res) => {
    cItems.value[0].num = res.communicateCount
    cItems.value[1].num = res.developingCount
    cItems.value[2].num = res.dealCount
    //TypeError: Cannot set properties of undefined (setting 'num')
    if(res.isPlanFinished){//非空处理
    cItems.value[3].num = res.isPlanFinished//原代码
    }
  })
}
const getMiniute = (seconds: number) => {
  return Math.floor(seconds / 60) + '分'
}

const convertMin = (seconds: number) => {
  return Math.floor(seconds / 60)
}

const rankingList: any = ref([
  {
    title: '直播排行榜',
    loadingInstance: null,
    type: 'month',
    roleType: 0,
    subType: 0,
    ranking: 0,
    empCount: 0,
    empRankingCount: 0,
    selectedValue: dayjs(),
    placeholder: '请选择月份',
    loadData: () => {
      loadRankData(0)
    },
    columns: [
      {
        prop: 'groupName',
        label: '组名'
      },
      {
        prop: 'empName',
        label: '姓名',
        roleType: 0,
      },
      {
        prop: 'statisticsCount',
        label: '人数'
      },
      {
        prop: 'ranking',
        label: '排名'
      }
    ],
    tableData: []
  },
  {
    title: '复播排行榜',
    loadingInstance: null,
    type: 'month',
    roleType: 0,
    subType: 0,
    ranking: 0,
    empCount: 0,
    empRankingCount: 0,
    selectedValue: dayjs(),
    placeholder: '请选择月份',
    loadData: () => {
      loadRankData(1)
    },
    columns: [
      {
        prop: 'groupName',
        label: '组名'
      },
      {
        prop: 'empName',
        label: '姓名',
        roleType: 0,
      },
      {
        prop: 'statisticsCount',
        label: '人数'
      },
      {
        prop: 'ranking',
        label: '排名'
      }
    ],
    tableData: []
  },
  {
    title: '成交金额排行榜',
    loadingInstance: null,
    type: 'month',
    roleType: 0,
    subType: 0,
    ranking: 0,
    empCount: 0,
    empRankingCount: 0,
    selectedValue: dayjs(),
    placeholder: '请选择月份',
    loadData: () => {
      loadRankData(2)
    },
    columns: [
      {
        prop: 'groupName',
        label: '组名'
      },
      {
        prop: 'empName',
        label: '姓名',
        roleType: 0,
      },
      {
        prop: 'statisticsCount',
        label: '成交金额'
      },
      {
        prop: 'ranking',
        label: '排名'
      }
    ],
    tableData: []
  },
  {
    title: '电话数据排行榜',
    loadingInstance: null,
    type: 'month',
    ranking: 0,
    empCount: 0,
    empRankingCount: 0,
    roleType: 0,
    subType: 0,
    businessType: 'voice',
    selectedValue: dayjs(),
    placeholder: '请选择',
    loadData: () => {
      loadRankData(3)
    },
    columns: [
      {
        prop: 'groupName',
        label: '组名'
      },
      {
        prop: 'empName',
        label: '姓名',
        roleType: 0,
      },
      {
        prop: 'statisticsCount',
        label: '次数',
        subType: 0
      },
      {
        prop: 'statisticsCount',
        label: '时长',
        subType: 1,
        format: getMiniute
      },
      {
        prop: 'ranking',
        label: '排名'
      }
    ],
    tableData: []
  }
])

const loadRankData = (index: number) => {
  rankingList.value[index].loadingInstance = ElLoading.service({
    lock: true,
    text: '正在加载中...',
    target: '.rank_' + index + ' .el-table__body-wrapper',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  let time:any = []
  const roleType = rankingList.value[index].roleType
  const subType = rankingList.value[index].subType
  const selectedValue = rankingList.value[index].selectedValue
  const type: any = rankingList.value[index].type
  if(selectedValue) {
    time = [
      dayjs(selectedValue).startOf(type).format('YYYY-MM-DD HH:mm:ss'),
      dayjs(selectedValue).endOf(type).format('YYYY-MM-DD HH:mm:ss'),
    ]
  } else {
    time = [
      dayjs().startOf(type).format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf(type).format('YYYY-MM-DD HH:mm:ss'),
    ]
  }
  const queryInfo = {
    type: index,
    timeSlot: time,
    roleType,
    subType
  }
  ranking(queryInfo).then((res) => {
    rankingList.value[index].tableData = res
    rankingList.value[index].loadingInstance.close()
  })
  if(role.value == 3) {
    myRanking(queryInfo).then((res) => {
      rankingList.value[index].empCount = res.empCount
      rankingList.value[index].ranking = res.ranking
      rankingList.value[index].empRankingCount = res.empRankingCount
    })
  }
}

const activeName = ref('live')
const chartTabs = ref([
  {
    name: 'live',
    title: '直播数据',
    options: {
      tooltip: {
        trigger: 'axis',       // 触发类型，'axis'表示坐标轴触发
        axisPointer: {        // 坐标轴指示器配置
          type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value',
        name: '人数',
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',  // 设置为虚线
            color: '#ccc'    // 虚线颜色
          }
        }
      },
      series: [
        {
          barWidth: 12,
          color: '#6232FF',
          data: [],
          type: 'bar'
        }
      ]
    }
  },
  {
    name: 'fubo',
    title: '复播数据',
    options: {
      tooltip: {
        trigger: 'axis',       // 触发类型，'axis'表示坐标轴触发
        axisPointer: {        // 坐标轴指示器配置
          type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value',
        name: '人数',
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',  // 设置为虚线
            color: '#ccc'    // 虚线颜色
          }
        }
      },
      series: [
        {
          barWidth: 12,
          color: '#6232FF',
          data: [],
          type: 'bar'
        }
      ]
    }
  },
  {
    name: 'succ',
    title: '成交数据',
    options: {
      tooltip: {
        trigger: 'axis',       // 触发类型，'axis'表示坐标轴触发
        axisPointer: {        // 坐标轴指示器配置
          type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value',
        name: '金额',
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',  // 设置为虚线
            color: '#ccc'    // 虚线颜色
          }
        }
      },
      series: [
        {
          barWidth: 12,
          color: '#6232FF',
          data: [],
          type: 'bar'
        }
      ]
    }
  },
  {
    name: 'voice',
    title: '电话数据',
    options: {
      tooltip: {
        trigger: 'axis',       // 触发类型，'axis'表示坐标轴触发
        axisPointer: {        // 坐标轴指示器配置
          type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: [{
        type: 'value',
        name: '通数',
        position: 'left',
        min: 0,
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',  // 设置为虚线
            color: '#ccc'    // 虚线颜色
          }
        }
      },
        {
          type: 'value',
          name: '时长/min',
          position: 'right',
          min: 0,
          splitLine: {
            show: false,
          }
        }],
      series: [
        {
          name: '通数',
          barWidth: 12,
          color: '#6232FF',
          data: [],
          type: 'bar'
        },
        {
          name: '时长/min',
          yAxisIndex: 1,
          color: '#FFC107',
          data: [],
          type: 'line'
        }
      ]
    }
  },
  {
    name: 'reply',
    title: '客户回复数据',
    options: {
      tooltip: {
        trigger: 'axis',       // 触发类型，'axis'表示坐标轴触发
        axisPointer: {        // 坐标轴指示器配置
          type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: ['回复1次', '回复2次','回复3次', '回复≥5次','回复≥10次']
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '回复1次',
          data: [],
          type: 'bar',
          barWidth: 12
        },
        {
          name: '回复2次',
          data: [],
          type: 'bar',
          barWidth: 12
        },
        {
          name: '回复3次',
          data: [],
          type: 'bar',
          barWidth: 12
        },
        {
          name: '回复≥5次',
          data: [],
          type: 'bar',
          barWidth: 12
        },
        {
          name: '回复≥10次',
          data: [],
          type: 'bar',
          barWidth: 12
        }
      ]
    }
  }
])

const loadColumnChart = (type: number) => {
  const queryInfo = {
    type: type
  }
  columnChart(queryInfo).then(res => {
    chartTabs.value[type].options.xAxis.data = res.map((item: any) => item.month)

    if(type == 3 && chartTabs.value[type].options.series[1]) {
      chartTabs.value[type].options.series[1].data = res.map((item: any) => Math.floor(item.extCount/60))
    }
    if(type == 4){
      chartTabs.value[type].options.series[0].data = res.map((item: any) => item.replyOneCount)
      chartTabs.value[type].options.series[1].data = res.map((item: any) => item.replyTwoCount)
      chartTabs.value[type].options.series[2].data = res.map((item: any) => item.replyThreeCount)
      chartTabs.value[type].options.series[3].data = res.map((item: any) => item.replyFiveCount)
      chartTabs.value[type].options.series[4].data = res.map((item: any) => item.replyTenCount)
    } else {
      chartTabs.value[type].options.series[0].data = res.map((item: any) => item.statisticsCount)
    }
  })
}
const userList: any = ref([])
const groupList: any = ref([])

const loadOverView = (tabIndex: number) => {
  const queryInfo = {
    type: tabIndex
  }
  const tab = userTabs.value[tabIndex]
  if(activeUserTab.value == tab.name) {
    tab.loadingInstance = ElLoading.service({
      lock: true,
      text: '正在加载中...',
      target: '.users-content',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  overview(queryInfo).then((res) => {
    if(tab.loadingInstance) {
      tab.loadingInstance.close()
    }
    res.forEach((user: any, index: number) => {
      let temp: any = userList.value.find((o: any) => o.name == user.empName)
      if(!temp) {
        temp = {
          name: user.empName
        }
        userList.value.push(temp)
      }
      temp[tab.name + 'index'] = index
      temp[tab.name] = []
      // 是否达标
      // temp['completed' + tab.name ] = user.isQualified
      tab.columns.forEach((column: any) => {
        temp[tab.name].push({
          label: column.label,
          value: column.format?column.format(user[column.prop]):user[column.prop]
        })
      })
    })
    if(activeUserTab.value == tab.name) {
      userList.value.sort((a: any, b: any) => {
        return a[tab.name + 'index'] - b[tab.name + 'index']
      })
    }
  })
}

const loadGroupOverView = (tabIndex: number) => {
  const queryInfo = {
    type: tabIndex
  }
  const tab = groupTabs.value[tabIndex]
  if(activeGroupTab.value == tab.name) {
    tab.loadingInstance = ElLoading.service({
      lock: true,
      text: '正在加载中...',
      target: '.groups-content',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  overview(queryInfo).then((res) => {
    if(tab.loadingInstance) {
      tab.loadingInstance.close()
    }
    res.forEach((group: any, index: number) => {
      let temp: any = groupList.value.find((o: any) => o.name == group.groupName)
      if(!temp) {
        temp = {
          name: group.groupName
        }
        groupList.value.push(temp)
      }
      temp[tab.name] = []
      temp[tab.name + 'index'] = index
      tab.columns.forEach((column: any) => {
        temp[tab.name].push({
          label: column.label,
          value: column.format?column.format(group[column.prop]):group[column.prop]
        })
      })
    })
    if(activeUserTab.value == tab.name) {
      groupList.value.sort((a: any, b: any) => {
        return a[tab.name + 'index'] - b[tab.name + 'index']
      })
    }
  })
}

const getIconColor = (percent: number) => {
  if(percent == 100) {
    return 'gc-right-top-green'
  } else if (percent >= 80) {
    return 'gc-right-top-blue'
  } else if (percent >= 60) {
    return 'gc-right-top-orange'
  } else {
    return 'gc-right-top-red'
  }
}

const addSpace = (str: String, data: any) => {
  if(str && data[activeUserTab.value] && data[activeUserTab.value].length > 0) {
    const longest = Math.max(...data[activeUserTab.value].map((item: { label: string; }) => item.label.replace("：","").length))
    data.strCnt = longest
    const strLength = str.replace("：","").length
    const padLength = (longest - strLength)/(strLength - 1)
    if(padLength == 0) {
      return str
    }
    let returnStr = "";
    let i = 0;
    str.split('').forEach(item => {
      if(i < (strLength - 1)) {
        returnStr += item + '<span style="width: '+ padLength +'em"></span>'
      } else {
        returnStr += item
      }
      i++;
    })
    return returnStr
  } else {
    return str
  }
}

const addGroupSpace = (str: String, data: any) => {
  if(str && data[activeGroupTab.value] && data[activeGroupTab.value].length > 0) {
    const longest = Math.max(...data[activeGroupTab.value].map((item: { label: string; }) => item.label.replace("：","").length))
    data.strGroupCnt = longest
    const strLength = str.replace("：","").length
    const padLength = (longest - strLength)/(strLength - 1)
    if(padLength == 0) {
      return str
    }
    let returnStr = "";
    let i = 0;
    str.split('').forEach(item => {
      if(i < (strLength - 1)) {
        returnStr += item + '<span style="width: '+ padLength +'em"></span>'
      } else {
        returnStr += item
      }
      i++;
    })
    return returnStr
  } else {
    return str
  }
}
const activeUserTab = ref('plan')

const changeUserTab = () => {
  userList.value.sort((a: any, b: any) => {
    return a[activeUserTab.value + 'index'] - b[activeUserTab.value + 'index']
  })
}

const userTabs: any = ref([
  {
    name: 'plan',
    label: '按沟通计划',
    loadingInstance: null,
    columns: [
      {
        label: '总数：',
        prop: 'statisticsCount'
      },
      {
        label: '开发数：',
        prop: 'developCount'
      },
      {
        label: '已成交：',
        prop: 'dealCount'
      },
      {
        label: '未沟通：',
        prop: 'noCommunicate'
      }
    ]
  },
  {
    name: 'live',
    label: '按直播数据',
    loadingInstance: null,
    columns: [
      {
        label:'总人数：',
        prop: 'statisticsCount'
      }
    ]
  },
  {
    name: 'fubo',
    label: '按复播数据',
    loadingInstance: null,
    columns: [
      {
        label:'总人数：',
        prop: 'statisticsCount'
      }
    ]
  },
  {
    name: 'voice',
    label: '按电话数据',
    loadingInstance: null,
    columns: [
      {
        label:'次数：',
        prop: 'callCount'
      },
      {
        label:'',
        prop: ''
      },
      {
        label:'总时长：',
        prop: 'callDuration',
        format: getMiniute
      },
      {
        label:'平均时长：',
        prop: 'averageCount',
        format: getMiniute
      }
    ]
  },
  {
    name: 'reply',
    label: '按客户回复数据',
    loadingInstance: null,
    columns: [
      {
        label:'回复客户数：',
        prop: 'statisticsCount'
      }
    ],
  }
])

const activeGroupTab = ref('plan')

const changeGroupTab = () => {
  groupList.value.sort((a: any, b: any) => {
    return a[activeGroupTab.value + 'index'] - b[activeGroupTab.value + 'index']
  })
}

const groupTabs: any = ref([
  {
    name: 'plan',
    label: '按沟通计划',
    columns: [
      {
        label: '总数：',
        prop: 'statisticsCount'
      },
      {
        label: '开发数：',
        prop: 'developCount'
      },
      {
        label: '已成交：',
        prop: 'dealCount'
      }
    ]
  },
  {
    name: 'live',
    label: '按直播数据',
    loadingInstance: null,
    columns: [
      {
        label:'总人数：',
        prop: 'statisticsCount'
      },
      {
        label:'平均人数：',
        prop: 'averageCount'
      }
    ]
  },
  {
    name: 'fubo',
    label: '按复播数据',
    loadingInstance: null,
    columns: [
      {
        label:'总人数：',
        prop: 'statisticsCount'
      },
      {
        label:'平均人数：',
        prop: 'averageCount'
      }
    ]
  },
  {
    name: 'voice',
    label: '按电话数据',
    columns: [
      {
        label:'次数：',
        prop: 'callCount'
      },
      {
        label:'',
        prop: ''
      },
      {
        label:'总时长：',
        prop: 'callDuration',
        format: getMiniute
      },
      {
        label:'平均时长：',
        prop: 'averageCount',
        format: getMiniute
      }
    ]
  },
  {
    name: 'reply',
    label: '按客户回复数据',
    columns: [
      {
        label:'回复客户数：',
        prop: 'statisticsCount'
      },
      {
        label:'平均客户数：',
        prop: 'averageCount'
      }
    ],
  }
])

const Timer: any = ref(null)

const timerStop = () => {
  clearInterval(Timer.value)
}

const timerStart = () => {
  Timer.value = setInterval(() => {
    const names = chartTabs.value.map(item => item.name)
    activeName.value = names[(names.indexOf(activeName.value) + 1) % names.length]
  }, 3000)
}

const getDateSelectFormat = (type: String) => {
  console.log('xxxxxxxxxxxxxxxxxxx')
  switch (type)
  {
    case 'day':
      return 'YYYY-MM-DD'
    case 'week':
      return '[第] ww [周]'
    case 'month':
      return 'YYYY-MM'
  }
}

const listDialogVisible = ref(false)
const listDialogTitle = ref('')
const listTableTitle = ref('');
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const pageInfo = ref({pageNo: 1, pageSize: 100})
const modalConfig = ref()

const overviewClick = (item: any) => {
  listDialogVisible.value = true;
  listDialogTitle.value = '详情记录'
  listTableTitle.value = '组员列表'

  switch (activeGroupTab.value) {
    case 'plan':
      listDialogTitle.value = '按沟通计划'
      modalConfig.value = planTableConfig
      break
    case 'live':
      listDialogTitle.value = '按直播数据'
      modalConfig.value = liveTableConfig
      break
    case 'fubo':
      listDialogTitle.value = '按复播数据'
      modalConfig.value = fuboTableConfig
      break
    case 'voice':
      listDialogTitle.value = '按电话数据'
      modalConfig.value = voiceTableConfig
      break
    case 'reply':
      listDialogTitle.value = '按客户回复数据'
      modalConfig.value = replyTableConfig
      break
    default:
      listDialogTitle.value = '按沟通计划'
      modalConfig.value = planTableConfig
      break
  }

  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据统计中...',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  groupDetails({group: item.name, type: activeGroupTab.value}).then((res) => {
    loadingInstance.close()
    dataList.value = res
    dataCount.value = Number(res.total)
  })
}

const dialogClose = () => {
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 100;
  dataCount.value = 0;
}

onMounted(() => {
  if(role.value <= 2) {
    cItems.value = cItems.value.filter((item: any) => item.name != '今日计划是否完成')
  }

  dayjs.locale('zh-cn')
  timerStart()
  // 并行运行
  loadNumStatistics()
  loadCommunicatePlan()
  loadColumnChart(0)
  loadColumnChart(1)
  loadColumnChart(2)
  loadColumnChart(3)
  loadColumnChart(4)

  loadRankData(0)
  loadRankData(1)
  loadRankData(2)
  loadRankData(3)

  if(role.value == 2) {
    loadOverView(0)
    loadOverView(1)
    loadOverView(2)
    loadOverView(3)
    loadOverView(4)
  } else if (role.value == 1 || role.value == 0) {
    loadGroupOverView(0)
    loadGroupOverView(1)
    loadGroupOverView(2)
    loadGroupOverView(3)
    loadGroupOverView(4)
  }

  if (role.value == 3) {
    loadEmpCallStatistics()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_BaseEchart = _resolveComponent("BaseEchart")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nums.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: item.icon
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(CountTo, {
                  value: item.num
                }, null, 8, ["value"])
              ])
            ]),
            (item.link)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ni-opt",
                  onClick: ($event: any) => (routeTo(item.link))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/ds-img/go.png')
                  }, null, 8, _hoisted_11)
                ], 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ]),
      (role.value == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"width":"100%"}
            }, {
              header: _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empCall.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          src: item.icon
                        }, null, 8, _hoisted_17)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1),
                        (index == 0 || index == 2 || index == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(CountTo, {
                                value: item.num
                              }, null, 8, ["value"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(CountTo, {
                                value: item.num
                              }, null, 8, ["value"]),
                              _hoisted_22
                            ]))
                      ])
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (role.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"width":"100%"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_tabs, {
                        modelValue: activeUserTab.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeUserTab).value = $event)),
                        onTabClick: changeUserTab
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userTabs.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_tab_pane, {
                              label: item.label,
                              name: item.name
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", _hoisted_28, _toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "name"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, "当前业务员数量：" + _toDisplayString(userList.value.length), 1)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  (userList.value.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(userList.value, (user, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(user.name.slice(-2)), 1),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString('No.' + (index+1)), 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(user.name), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass('uc-num ' + ((user[activeUserTab.value]&&user[activeUserTab.value].length > 2)?'':'uc-num-col')),
                              style: {zoom: 0.82}
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user[activeUserTab.value], (userPlan, index) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("div", {
                                    class: "uc-num-item-name",
                                    style: _normalizeStyle({width:user.strCnt + 1 +'em'}),
                                    innerHTML: addSpace(userPlan.label, user)
                                  }, null, 12, _hoisted_37),
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(userPlan.value), 1)
                                ]))
                              }), 256))
                            ], 2)
                          ])
                        ]))
                      }), 256))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "暂无数据",
                        style: {"margin":"auto"}
                      }))
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (role.value < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"width":"100%"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_el_tabs, {
                        modelValue: activeGroupTab.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeGroupTab).value = $event)),
                        onTabClick: changeGroupTab
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupTabs.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_tab_pane, {
                              label: item.label,
                              name: item.name
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("div", _hoisted_44, _toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "name"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", null, "当前小组数量：" + _toDisplayString(groupList.value.length), 1)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_46, [
                  (groupList.value.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groupList.value, (group, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "g-item",
                          onClick: ($event: any) => (overviewClick(group))
                        }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("img", {
                              src: require('@/assets/ds-img/group.png')
                            }, null, 8, _hoisted_49)
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, _toDisplayString('No.' + (index + 1)), 1),
                            _createElementVNode("div", _hoisted_52, _toDisplayString(group.name), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass('gc-num ' + (group[activeGroupTab.value] && group[activeGroupTab.value].length > 2?'':'gc-num-col')),
                              style: {zoom: 0.92}
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group[activeGroupTab.value], (groupPlan, index) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _createElementVNode("div", {
                                    class: "gc-num-item-name",
                                    style: _normalizeStyle({width:group.strGroupCnt + 1 +'em'}),
                                    innerHTML: addGroupSpace(groupPlan.label, group)
                                  }, null, 12, _hoisted_54),
                                  _createElementVNode("div", _hoisted_55, _toDisplayString(groupPlan.value), 1)
                                ]))
                              }), 256))
                            ], 2)
                          ])
                        ], 8, _hoisted_47))
                      }), 256))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        description: "暂无数据",
                        style: {"margin":"auto"}
                      }))
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_el_card, { shadow: "never" }, {
            header: _withCtx(() => [
              _hoisted_58
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_59, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cItems.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("img", {
                        src: item.icon
                      }, null, 8, _hoisted_62)
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, _toDisplayString(item.name), 1),
                      (item.isFlag)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(item.num), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createVNode(CountTo, {
                              value: item.num
                            }, null, 8, ["value"])
                          ]))
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_component_el_tabs, {
            stretch: true,
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeName).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartTabs.value, (chart, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  name: chart.name
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_68, _toDisplayString(chart.title), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(chart.name + ' chart'),
                      onMouseenter: timerStop,
                      onMouseleave: timerStart
                    }, [
                      (chart.options)
                        ? (_openBlock(), _createBlock(_component_BaseEchart, {
                            key: 0,
                            class: "exchangeChart",
                            options: chart.options,
                            width: "1200px"
                          }, null, 8, ["options"]))
                        : _createCommentVNode("", true)
                    ], 34)
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_69, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankingList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass('r-item rank_' + index)
          }, [
            _createVNode(_component_el_card, { style: {"width":"100%"} }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createElementVNode("div", _hoisted_73, _toDisplayString(item.title), 1),
                    (role.value == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          (item.empRankingCount > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                (item.ranking > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_76, "（我的排名：" + _toDisplayString(item.ranking) + " | 榜单人数：" + _toDisplayString(item.empRankingCount) + ")", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_77, "（我的排名：未上榜 | 榜单人数：" + _toDisplayString(item.empRankingCount) + "）", 1))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createVNode(_component_el_select, {
                      style: {"width":"90px","margin-right":"12px"},
                      modelValue: item.roleType,
                      "onUpdate:modelValue": ($event: any) => ((item.roleType) = $event),
                      size: "mini",
                      onChange: item.loadData,
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "个人",
                          value: 0
                        }),
                        _createVNode(_component_el_option, {
                          label: "分组",
                          value: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                    (item.businessType)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          style: {"width":"90px","margin-right":"12px"},
                          modelValue: item.subType,
                          "onUpdate:modelValue": ($event: any) => ((item.subType) = $event),
                          size: "mini",
                          onChange: item.loadData,
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "次数",
                              value: 0
                            }),
                            _createVNode(_component_el_option, {
                              label: "时长",
                              value: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_select, {
                      style: {"width":"90px"},
                      modelValue: item.type,
                      "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                      size: "mini",
                      onChange: item.loadData,
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "月",
                          value: "month"
                        }),
                        _createVNode(_component_el_option, {
                          label: "周",
                          value: "week"
                        }),
                        _createVNode(_component_el_option, {
                          label: "日",
                          value: "day"
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                    _createVNode(_component_el_date_picker, {
                      style: {"width":"130px","margin-left":"12px"},
                      size: "mini",
                      onChange: item.loadData,
                      modelValue: item.selectedValue,
                      "onUpdate:modelValue": ($event: any) => ((item.selectedValue) = $event),
                      format: getDateSelectFormat(item.type),
                      type: item.type,
                      placeholder: item.placeholder
                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "format", "type", "placeholder"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_el_table, {
                    fit: true,
                    data: item.tableData,
                    style: {"width":"100%"},
                    "header-cell-style": {background: '#F5F7FB'}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.columns.filter(column => (typeof column.subType == 'undefined' || column.subType == item.subType) && (typeof column.roleType == 'undefined' || column.roleType == item.roleType)), (column, index) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          align: "center",
                          prop: column.prop,
                          label: column.label
                        }, {
                          default: _withCtx((scope) => [
                            (column.prop == 'ranking')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                  (scope.row[column.prop] == 1)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: require('@/assets/ds-img/first.png')
                                      }, null, 8, _hoisted_81))
                                    : (scope.row[column.prop] == 2)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: require('@/assets/ds-img/second.png')
                                        }, null, 8, _hoisted_82))
                                      : (scope.row[column.prop] == 3)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 2,
                                            src: require('@/assets/ds-img/third.png')
                                          }, null, 8, _hoisted_83))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(scope.row[column.prop]), 1))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(column.format?column.format(scope.row[column.prop]):scope.row[column.prop]), 1))
                          ]),
                          _: 2
                        }, 1032, ["prop", "label"]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ])
              ]),
              _: 2
            }, 1024)
          ], 2))
        }), 256))
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass('toolbar-container ' + (open.value?'open':'close')),
          onMouseenter: changeOpen,
          onMouseleave: changeClose
        }, [
          (open.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tools.value, (tool, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("img", {
                        src: tool.icon
                      }, null, 8, _hoisted_89)
                    ]),
                    _createElementVNode("div", _hoisted_90, _toDisplayString(tool.label), 1)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_91, [
      _createVNode(_component_el_dialog, {
        title: listDialogTitle.value,
        modelValue: listDialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listDialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: listTableTitle.value
          }, modalConfig.value, {
            page: pageInfo.value,
            "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((pageInfo).value = $event))
          }), {
            callDuration: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(convertMin(scope.row.callDuration)), 1)
            ]),
            averageCount: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(convertMin(scope.row.averageCount)), 1)
            ]),
            _: 1
          }, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ]))
}
}

})